import { Form } from 'react-bootstrap';
import Col from 'react-bootstrap/Col';
import { useWatch } from 'react-hook-form';
import { UseFormReturn } from 'react-hook-form/dist/types/form';
import { ProviderCredentialingRatesAndDifferentials } from '../../../api';
import { FormTextField } from '../../../app/components/FormTextField';
import { InfoIcon } from '../../../app/components/InfoIcon';
import { TooltippedText } from '../../../app/components/TooltippedText';
import { IShiftOption } from './models';

export interface IProviderRateControlProps {
  shift: IShiftOption;
  control: UseFormReturn['control'];
  register: UseFormReturn['register'];
  errors: UseFormReturn['formState']['errors'];
  blockInvalidChar: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  onResetControl: (name: keyof ProviderCredentialingRatesAndDifferentials) => void;
}

export const ProviderRateControl = ({
  shift,
  register,
  errors,
  blockInvalidChar,
  control,
  onResetControl,
}: IProviderRateControlProps) => {
  const controlAvailability = useWatch({ control, name: shift.availabilityControlName });

  return (
    <Form.Group className="mb-3 row">
      <Form.Check
        className="col-6 profile-rate-control"
        id={shift.type.toString()}
        label={
          <>
            <div className="d-flex align-items-center">
              <span>{shift.label}</span>
              <span className="profile-info-wrapper">
                <TooltippedText tooltipContent={shift.tooltipText}>
                  <InfoIcon size={12} className="profile-info-icon" />
                </TooltippedText>
              </span>
            </div>
          </>
        }
        type="checkbox"
        {...register(shift.availabilityControlName, {
          onChange: (event) => {
            if (!event.target.checked) {
              onResetControl(shift.controlName);
            }
          },
        })}
      />

      {controlAvailability && (
        <Col className="col-6" xs={12} md={6}>
          <FormTextField
            className="mb-0"
            label=""
            srOnlyLabel={true}
            name={shift.controlName}
            type="number"
            min={0}
            step="any"
            register={register}
            errors={errors}
            onKeyDown={blockInvalidChar}
            inputInfo="$ / Hour"
          />
        </Col>
      )}
    </Form.Group>
  );
};
